import { Application } from "@hotwired/stimulus";
import { initDidact } from "../apps/init";
import { initStimulus } from "../controllers/init";
import { Didact } from "../lib/Didact";

type PlausibleOptions = Record<string, unknown>;

type PlausibleQueue = {
  q?: unknown[][];
  o?: PlausibleOptions;
  init?: (options?: PlausibleOptions) => void;
};

type PlausibleFunction = ((...args: unknown[]) => void) & PlausibleQueue;

declare global {
  interface Window {
    Stimulus: Application;
    Didact: Didact;
    plausible?: PlausibleFunction | PlausibleQueue;
  }
}

const initPlausible = () => {
  const existing = window.plausible;

  if (existing?.init) {
    existing.init();
    return;
  }

  const queue: PlausibleFunction = (...args: unknown[]) => {
    queue.q = queue.q || [];
    queue.q.push(args);
  };

  queue.q = typeof existing === "object" ? existing.q : [];
  queue.o = {};
  queue.init = (options: PlausibleOptions = {}) => {
    queue.o = options;
  };
  queue.init();

  window.plausible = queue;
};

const main = () => {
  console.log("Vite ⚡️ Rails");

  window.Stimulus = initStimulus();
  window.Didact = initDidact();
};

initPlausible();

document.addEventListener("DOMContentLoaded", () => main());
